import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

@Component({
  selector: 'app-filter-resume-results-by-date',
  templateUrl: './filter-resume-results-by-date.page.html',
  styleUrls: ['./filter-resume-results-by-date.page.scss'],
})

export class FilterResumeResultsByDatePage implements OnInit {
  @Input() selectedRange: any;
  @Input() currentMonth: any;
  startDateFilter: any;
  endDateFilter: any;
  startDate?: string;
  endDate?: string;

  constructor(
    private modalController: ModalController,
  ) { }

  ngOnInit() {
    this.calcularFechas();
  }

  onSegmentChange(event: any) {
    this.selectedRange = event.detail.value;
    this.calcularFechas();
  }

  onRangeChange() {
    let data: any = {
      selected_range: this.selectedRange,
    }

    if (this.startDateFilter && this.endDateFilter) {
      data.start_date = this.startDateFilter
      data.end_date = this.endDateFilter
    }

    this.modalController.dismiss(data, 'confirm');
  }

  calcularFechas() {
    const today = new Date();
    let start: Date;
    let end: Date;

    switch (this.selectedRange) {
      case this.currentMonth:
        start = new Date(today.getFullYear(), today.getMonth(), 1);
        end = today;
        break;
      case 'Mes Anterior':
        start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        end = new Date(today.getFullYear(), today.getMonth(), 0);
        break;
      case 'Últimos Siete Días':
        end = today;
        start = new Date(today);
        start.setDate(end.getDate() - 7);
        break;
      case 'Este Mes':
        start = new Date(today.getFullYear(), today.getMonth(), 1);
        end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        break;
      case 'Personalizado':
        start = this.startDate ? new Date(this.startDate) : undefined;
        end = this.endDate ? new Date(this.endDate) : undefined;
        break;
      default:
        start = today;
        end = today;
    }

    this.startDate = start ? this.formatearFecha(start) : undefined;
    this.endDate = end ? this.formatearFecha(end) : undefined;
  }

  formatearFecha(fecha: Date): string {
    const dd = String(fecha.getDate()).padStart(2, '0');
    const mm = String(fecha.getMonth() + 1).padStart(2, '0'); // Mes empieza en 0
    const yyyy = fecha.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  }

  closeModal() {
    this.modalController.dismiss(null, null);
  }
}
